import styled from 'styled-components';

export const DownloadButtonGrid = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: -30px;

  button {
    max-width: 100px;
  }
`;

export const Image = styled.img`
  width: 16px;
`;
export const CardHeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const CardHeaderTopColumn = styled.div`
  display: flex;
  align-items: center;

  h3 {
    margin-bottom: 0;
  }
`;
